import { IDropdownOption, makeStyles, Text } from '@fluentui/react';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { DIETARY_REQUIREMENTS_INITIAL_VALUES } from '../../constants';
import { TravelerValues } from '../../types';
import { TravelerCommonData_dietaryRequirements_nodes } from '../../__generated__/TravelerCommonData';
import { DietaryRequirementsInputRow } from './DietaryRequirementsInputRow';

interface DietaryRequirementsInputProps {
  dietaryRequirements: TravelerCommonData_dietaryRequirements_nodes[];
  inputsDisabled: boolean;
}
export interface DietaryRequirementsOptionsProps extends IDropdownOption {
  isDescriptionRequired: boolean | null;
}

const useStyles = makeStyles((theme) => ({
  dietaryRequirements: {
    marginBottom: 20,
  },
}));

export const DietaryRequirementsInput: React.FC<
  DietaryRequirementsInputProps
> = ({ dietaryRequirements, inputsDisabled }) => {
  const styles = useStyles();
  const { control, watch } = useFormContext<TravelerValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'travelerDietaryRequirementsByTravelerId',
  });
  const rows = watch('travelerDietaryRequirementsByTravelerId') || [];

  return (
    <>
      <Text variant="xLarge" className={styles.dietaryRequirements}>
        Dietary Requirements
      </Text>
      {fields.map((field, index) => {
        const item = rows[index];
        const isLast = index === rows.length - 1;
        const isFirstRow = index === 0;

        const dietaryRequirementsOptions: DietaryRequirementsOptionsProps[] =
          dietaryRequirements
            .filter(
              (type) =>
                type.id === item?.dietaryRequirementId ||
                !rows.some((row) => row.dietaryRequirementId === type.id)
            )
            .map((type) => ({
              key: type.id,
              text: type.description || '',
              isDescriptionRequired: type.isDescriptionRequired,
            }));

        return (
          <DietaryRequirementsInputRow
            key={field.id}
            fieldName={`travelerDietaryRequirementsByTravelerId.${index}`}
            dietaryRequirementsOptions={dietaryRequirementsOptions}
            onChange={() => {
              if (isLast && dietaryRequirementsOptions.length > 1)
                append({ ...DIETARY_REQUIREMENTS_INITIAL_VALUES });
            }}
            onRemove={() => {
              remove(index);
              if (dietaryRequirementsOptions.length === 1) {
                append({ ...DIETARY_REQUIREMENTS_INITIAL_VALUES });
              }
            }}
            isFirstRow={isFirstRow}
            rowIndex={index}
            inputsDisabled={inputsDisabled}
          />
        );
      })}
    </>
  );
};